import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'lib-form-header',
  templateUrl: './form-header.component.html',
  styleUrls: ['./form-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormHeaderComponent implements OnInit {
  @Input() open;
  @Input() tooltipText: string;
  @Input() header;
  @Input() translatedHeader;
  @Input() required;
  @Input() dottedTitle = false;
  @Input() toggleOpen = true;
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  collapse() {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }
}
